export default __webpack_public_path__ + "static/rent-image-f86ba7015057c7eaa5aa201b43025f6a.png";